import i18n from 'i18next';
import { PUBLIC_I18N_URL_ENV } from 'tools/environments';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export async function initI18n(
	locale: string,
	supportedLocales: string[] = ['en']
) {
	if (i18n.isInitialized) {
		if(i18n.language !== locale) {
			await i18n.changeLanguage(locale);
		}
		return i18n;
	}	

	await i18n
		.use(HttpBackend)
		.use(initReactI18next)
		.init({
			debug: false,
			lng: locale,
			fallbackLng: 'en',
			supportedLngs: supportedLocales,
			backend: {
				loadPath: `${PUBLIC_I18N_URL_ENV}/{{lng}}.json`,
			},
			interpolation: {
				escapeValue: false,
			},
			react: {
				useSuspense: false,
			},
		});
	return i18n;
}